import { render, staticRenderFns } from "./EventRegister.vue?vue&type=template&id=2f19863f&scoped=true&lang=pug"
import script from "./EventRegister.vue?vue&type=script&lang=ts"
export * from "./EventRegister.vue?vue&type=script&lang=ts"
import style0 from "./EventRegister.vue?vue&type=style&index=0&id=2f19863f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f19863f",
  null
  
)

export default component.exports